// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"229":"c4f31e02","688":"c4f31e02","699":"c4f31e02"}[chunkId] + ".chunk.css";
};